<template>
  <div id="RingGraph" :style="{ width: width, height: height }" />
</template>
<script>
import echarts from "echarts";

require("echarts/lib/chart/bar");
export default {
  data() {
    //  饼状图

    return {
      chart: null,
      arr: [],
    };
  },

  props: {
    className: {
      type: String,
      default: "chart",
    },
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "12vw",
    },
    // getData: {
    //   type: Array,
    //   default: []
    // },
    title: {
      type: String,
    },
  },
  mounted() {},
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.clear();
    this.chart = null;
  },
  methods: {
    initChart(data) {
      // var arr = [
      //   { value: obj.Person2, name: "刑满释放人员 " + obj.Person2 + "人" },
      //   { value: obj.Person3, name: "社区矫正人员 " + obj.Person3 + "人" },
      //   { value: obj.Person4, name: "精神障碍患者 " + obj.Person4 + "人" },
      //   { value: obj.Person5, name: "吸毒人员 " + obj.Person5 + "人" },
      //   { value: obj.Person6, name: "残疾人员 " + obj.Person6 + "人" },
      // ]
      var total = 0;
      data.forEach((e) => {
        total += e.Value;
      });
      var arr = data.map((x) => {
        return {
          value: x.Value,
          name: x.Name + "(" + Math.floor((x.Value / total) * 100) + "%)",
        };
      });
      this.chart = echarts.init(document.getElementById("RingGraph"));
      const subText = arr.map((i) => i.value).reduce((pre, cur) => pre + cur);

      // console.log(_this.title)
      this.chart.setOption({
        title: {
          //text: "渠道数量 " + data.length,
          subtext: "",
          left: "center",
          y: "bottom",
          textStyle: {
            fontWeight: "none",
            fontSize: "16",
            color: "#fff",
          },
        },
        tooltip: {
          trigger: "item",
        },
        // legend: {
        //   orient: "vertical",
        //   icon: 'circle',
        //   left: "left",
        //   textStyle: {
        //     fontSize: 16,
        //     color: "#fff",
        //   },
        //},
        // 图例图例样式
        color: [
          "#ffd200",
          "#00d985",
          "#ed3d3d",
          "#1dceda",
          "#fff",
          "#b956ff",
          "#ffc64e",
          "#fff",
          "#01d7e5",
          "#598bc9",
          "#ff5fa7",
        ],
        series: [
          {
            name: "渠道接入占比",
            type: "pie",
            radius: ["40%", "70%"],
            data: arr,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
            label: {
              alignTo: "edge",
              margin: 20,
              show: true,
              fontSize: "16",
              fontWeight: "bold",
            },
          },
        ],

        // // 标题
        // title: {
        //   //text: '渠道数量 ' + data.length,
        //   // left: '23%',
        //   // bottom: '6%',
        //   x:'center',
        //   y:'top',
        //   textAlign:"center",
        //   textStyle: {
        //     fontWeight: 'none',
        //     color: '#fff',
        //   },
        // },
        // //  hove 展示得标题
        // tooltip: {
        //   trigger: 'item',
        //   formatter: '{b}',
        //   //formatter: '{a} <br/>{b}:{c}({d}%)'
        // },
        // // 图例
        // legend: {
        //   orient: 'vertical',
        //   icon: 'circle',
        //   // right: 50,
        //   // top: 10,
        //   // itemGap: 14,
        //   // itemWidth: 30,
        //   // itemHeight: 20,
        //   x:"left",
        //   y:"center",
        //   textStyle: {
        //     fontSize: 16,
        //     color: '#fff',
        //   },
        // },

        // // 图例图例样式
        // color: ['#ffd200','#00d985','#ed3d3d','#1dceda','#fff','#b956ff','#ffc64e', '#fff', '#01d7e5', '#598bc9', '#ff5fa7'],
        // // 饼状设置
        // series: [
        //   {
        //     name: '渠道接入占比',
        //     type: 'pie',
        //     //radius:'50%',
        //     radius: ['45%', '65%'],
        //     //center: ['25%', '40%'],
        //     avoidLabelOverlap: true,
        //     label: {
        //       formatter: '{c}',
        //       show: false,
        //       position: 'center',
        //     },

        //     emphasis: {
        //       label: {
        //         show: true,
        //         fontSize: '30',
        //         fontWeight: 'bold',
        //       },
        //     },
        //     labelLine: {
        //       show: true,
        //     },
        //     data: arr,
        //     emphasis: {
        //       itemStyle: {
        //         shadowBlur: 0,
        //         shadowOffsetX: 0,
        //         shadowColor: 'rgba(0, 0, 0, 0.5)',
        //       },
        //     },
        //   },
        // ],
      });
    },
  },
};
</script>
